﻿import CONFIG from '../config';
import { Injectable, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { BackendService } from './backend.service';
//import { NotificationService } from '../notification/notification.service';
import { Utilities } from './utility-services.service';

import { Observable } from 'rxjs/Observable';
import { NotificationService } from '../notification.service';

@Injectable()
export class AuthGuard extends Utilities implements CanActivate {
    constructor(
        private _router: Router,
        public location: Location,
        public notificationService: NotificationService,
        public authService: AuthService,
        public backendService: BackendService
    ) {
        super(location, notificationService, authService, backendService);
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let jwt = localStorage.getItem('token') || sessionStorage.getItem('token');
        if(jwt) {
            return this.checkLoginForAuthGuard();
        } else {
            this.authService.loggedIn = false;
            this._router.navigate(['/login']);
            return Observable.of(false);
        }
    }
}